<template>
  <span class="channelcount">{{channelcount}}</span>
</template>

<script>
import firebase from "@/components/FirebaseInit";

export default {
  name: "channelcount",
  components: {},
  data() {
    return {
      database: null,
      entriesRef: null,
      entrycount: 0
    };
  },
  created: function() {
    this.entriesRef = firebase.collection("entries");
    this.entriesRef.onSnapshot(() => {
      this.updateEntryCount();
    });
  },
  computed: {
    channelcount: function() {
      return this.entrycount;
    }
  },
  methods: {
    updateEntryCount: function() {
      let entryCount = 0;
      this.entriesRef
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if(doc.data().entryUrl) {
              entryCount++;
            }
          });
          this.entrycount = entryCount;
        })
        .catch(error => {
          this.showDbError(error);
        });
    }
  }
};
</script>
